<template>
    <slot data-bs-toggle="modal" :data-bs-target="'#BuySub' + TbtnId" :click="openModal"></slot>
        <div class="modal fade" tabindex="-1" :id="'BuySub' + TbtnId" data-bs-backdrop="false" >
          <div class="modal-dialog modal-xl" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">아이디주문</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" style="padding:40px;">

                <table class="table" >
                  <tbody>
                    <tr>

                      <td colspan="3" style="text-align:left; ">




<table class="table" style="border-top:1px solid #ccc;">
  <colgroup>
    <col style="width:25%;" />
    <col style="width:25%;" />
    <col style="width:25%;" />
    <col style="width:25%;" />
  </colgroup>
  <tr>
<th>아이디</th>
<td><template  v-if="hide_order_studentName">{{selStudent.username}} <student :student="selStudent" /></template></td>
<th>연장유무</th>
<td><input style="display:inline; width:20px; height:20px;" type="checkbox" v-model="is_extend" @change="chgExtend()" :disabled="(this.$refs.qg && this.$refs.qg.checked.length != 1) || hide_order_previousSub" /> 연장</td>
  </tr>
</table>

<query-grid :config="config" ref="qg" v-if="!hide_order_studentName">
<template #items="props">
<tr v-for="record in props.records" v-bind:key="record.id" :class="{'table-danger': record.is_deleted}" >
<td scope="col"><input type="checkbox" v-model="record.checked" @click="is_extend = false;chgExtend()"></td>
<td scope="row" style="text-align:center;">{{ record.id }}</td>
<td style="text-align:center;">
<Business v-if="record.t2" :biz="record.t2" /></td>
<td v-if="this.$root.guiPerm != 'CLASS' && this.$root.guiPerm != 'ENTERPRISE'" style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" />

</td>
<td style="text-align:center;"><!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
@click="moreStudentInfo(record)">{{ record.username }}</a-->
{{ record.username }}
</td>
<td style="text-align:center;">
  {{ record.name }}
</td>
<td style="text-align:center;"><span v-if="record.type === 'MYPATH'">MY PATH</span>
<span v-if="record.type === 'MYUSE'">MY USE</span>
</td>
<td style="text-align:center;">{{ record.level }}</td>
<td style="text-align:center;"><span v-if="record.startDate">{{ record.startDate.substr(2, 8) }}</span></td>
<td style="text-align:center;"><span v-if="record.endDate">{{ record.endDate.substr(2, 8) }}</span></td>
<td style="text-align:center;"><span v-if="record.endDate"  :style="{'color': getDiff(record.endDate) <= 0 ? 'red': ''}">{{ getDiff(record.endDate) + ' 일' }}</span></td>

<td style="text-align:center;"><span v-if="!record.active_subscription_id" style="background:#ff0000;color:#fff;padding:2px 6px; font-size:12px;">미사용</span><template v-else><span
v-if="record.ranking_exception" style="background:#ffcc00;color:#333; padding:2px 6px; font-size:12px;">이벤트</span><span v-else style="background:#0071e3;color:#fff; padding:2px 6px; font-size:12px;">정회원</span></template></td>

</tr>
</template>

</query-grid>

         <span style="color:#ff0000;">  <template v-if="this.$refs.qg && this.$refs.qg.checked.length > 1">연장 기능은 1명 선택 시에만 사용 가능합니다</template>
          <template v-if="this.$refs.qg && this.$refs.qg.checked.length < 1"> 연장에 체크하려면 회원을 먼저 선택하세요.</template></span>

        </td>
                      <!-- 회원정보에서 상품구매시 해당 회원정보 가지고 올 것 -->
                      <!--<strong>학생명</strong>
  -->


                    </tr>

                  </tbody>
                </table>

                <template v-if="is_extend">

                <table class="table" style="border-top:1px solid #ccc;">
                  <tbody>
                    <tr>
                      <th scope="row" >이전 아이디(상품) 선택</th>
                      <td colspan="3" ><select class="hidtype" v-model="addData.subscription" @change="this.fetchProducts(addData.subscription);" v-if="!hide_order_previousSub">
                    <template :key="subscription.id" v-for="subscription in ext_subscriptions">
                      <option :value="subscription" v-if="subscription.status == 'ACTIVE'">
                        {{ subscription.productName }}</option>
                    </template>
                  </select>
                  <template v-else>
                      연장할 아이디가 선택되었습니다.({{selStudent.username}}) <subscription :subscription="addData.subscription" />
                  </template>
                  </td>
                      <!-- 회원정보에서 상품구매시 해당 회원정보 가지고 올 것 -->
                      <!--<strong>학생명</strong>
  -->


                    </tr>
                  </tbody>
                </table>
                </template>
                <h5 class="h5_point">상품선택</h5>
                      <table class="table" style="border-top:1px solid #ccc;">
                  <tbody>
                    <tr>
                      <th scope="row">메인상품</th>
                      <td>
                        <select class="hidtype" v-model="selmain" @change="this.fetchProductsmain();" :value="selmain">
                          <option value="">메인상품을 선택해 주세요</option>
                          <option value="B">MyUse</option>
                          <option value="A">MyPath</option>
                          <option value="C">MyUse+MyPath</option>
                        </select>
                      </td>
                      <th scope="row">개월수</th>
                      <td>
                        <select class="hidtype" v-model="selmonth" @change="this.fetchProductsmain();">
                          <option value="">개월수를 선택해 주세요</option>
                          <option value="1">1개월</option>
                          <option value="2">2개월</option>
                          <option value="3">3개월</option>
                        </select>
                      </td>
                      <th scope="row">부가서비스</th>
                      <td>

                        <select class="hidtype" v-model="selservice" @change="this.fetchProductsmain();">
                          <template  v-if="hide_selservice">
                            <option value="">부가서비스를 선택해 주세요</option>
                            <option value="bookclubs">북클럽</option>
                            <option value="vocajoa">보카조아</option>
                            <option value="all">북클럽+보카조아</option>
                          </template>
                        </select>

                      </td>
                    </tr>
                  </tbody>
                </table>
                  <table class="table table_point">
                  <thead>
                    <tr>
                      <th>선택</th>
                      <th>#</th>
                      <th>상품명</th>
                      <th>상품구분</th>
                      <th>북클럽</th>
                      <th>보카조아</th>
                      <th>가격</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="product in products" v-bind:key="product.id">
                      <td style="height:50px;"><input type="radio" name="product" style="width:16px; height:16px;" v-on:click="selProduct=product" /></td>
                      <td scope="row"  >{{ product.id }}</td>
                      <td style="color:#0071e3;font-weight:bold;">{{ product.name }}</td>
                      <td><span v-if="product.product === 'MYPATH'">MyPath</span>
                        <span v-if="product.product === 'MYUSE'">MyUSE</span></td>
                      <td><span v-if="product.bookclubs">O</span>
                        <span v-if="!product.bookclubs">X</span></td>
                      <td><span v-if="product.vocajoa">O</span>
                        <span v-if="!product.vocajoa">X</span></td>
                      <td>{{parseInt(product.price).toLocaleString()}}원</td>
                    </tr>

                  </tbody>
                </table>
                <h5 class="h5_point">결제정보</h5>
                <table class="table table_point">
                  <colgroup>
                    <col style="width:25%;" />
                    <col style="width:25%;" />
                    <col style="width:25%;" />
                    <col style="width:25%;" />
                  </colgroup>

                  <tbody>
                    <tr>
                      <th scope="row">상품명</th>
                      <td style="color:#0071e3;font-weight:bold;">{{ selProduct.name }}</td>
                      <th scope="row">금액</th>
                      <td>{{ selProduct.price }}원</td>
                    </tr>
                    <tr>
                      <th scope="row">기간</th>
                      <td>{{ selProduct.period }}개월</td>
                      <th scope="row">비고</th>
                      <td></td>
                    </tr>
                    <tr>
                      <th scope="row">결제방법</th>
                      <td style="text-align:center;"> <select v-model="payMethod"  style="width:200px; font-size:14px; border:1px solid #ccc; padding:10px;">
                          <option disabled value="">결제방식을 선택해 주세요</option>
                          <option value="CARD_ONPG">온라인 신용카드(문자전송)</option>
                          <option value="CASH">현금(자동세팅 불가)</option>
                          <option value="CARD_OFFPG" disabled>오프라인 신용카드(개발중)</option>
                        </select></td>


                      <th scope="row"></th>
                      <td></td>
                    </tr>
                    <tr v-if="!is_extend">
                      <th scope="row">레벨</th>
                      <template v-if="this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL1'">
                    <td><select class="hidtype" v-model="addData.level">
                      <option disabled>레벨을 선택해 주세요</option>
                      <option value="GK">GK</option>
                      <option value="GK_1" v-if="selProduct.product == 'MYUSE'">GK_1</option>
                      <option value="GR1">GR1</option>
                      <option value="GR2">GR2</option>
                      <option value="GR3">GR3</option>
                      <option value="GR4">GR4</option>
                      <option value="GR5">GR5</option>
                      <template  v-if="selProduct.product == 'MYPATH'">
                      <option value="GR6">GR6</option>
                      <option value="GR7">GR7</option>
                      <option value="GR8">GR8</option>
                      <option value="GR9">GR9</option>
                      <option value="GR10">GR10</option>
                      <option value="GR11">GR11</option>
                      <option value="GR12">GR12</option>
                      </template>
                      <option value="Sprout">Sprout</option>
                      <option value="Blow">Blow</option>
                      <option value="Flag">Flag</option>
                      <option value="Wing">Wing</option>
                      <option value="Dream">Dream</option>
                      <option value="Royal">Royal</option>
                    </select></td>
                  </template>
                  <template v-else>
                    <template v-if="this.$root.businesses[0].study_type != 'ALS'">
                      <td><select class="hidtype" v-model="addData.level">
                        <option disabled>레벨을 선택해 주세요</option>
                        <option value="GK">GK</option>
                        <option value="GK_1" v-if="selProduct.product == 'MYUSE'">GK_1</option>
                        <option value="GR1">GR1</option>
                        <option value="GR2">GR2</option>
                        <option value="GR3">GR3</option>
                        <option value="GR4">GR4</option>
                        <option value="GR5">GR5</option>
                        <template  v-if="selProduct.product == 'MYPATH'">
                        <option value="GR6">GR6</option>
                        <option value="GR7">GR7</option>
                        <option value="GR8">GR8</option>
                        <option value="GR9">GR9</option>
                        <option value="GR10">GR10</option>
                        <option value="GR11">GR11</option>
                        <option value="GR12">GR12</option>
                        </template>
                      </select></td>
                    </template>
                    <template v-else>
                      <td><select class="hidtype" v-model="addData.level">
                        <option disabled>레벨을 선택해 주세요</option>
                        <option value="Sprout">Sprout</option>
                        <option value="Blow">Blow</option>
                        <option value="Flag">Flag</option>
                        <option value="Wing">Wing</option>
                        <option value="Dream">Dream</option>
                        <option value="Royal">Royal</option>
                      </select></td>
                    </template>
                  </template>
                      <th scope="row">시작희망일</th>
                      <td><input type="date" class="hidtype" id="hopeDate" v-model="addData.hopeStart" :disabled="is_extend"/></td>
                    </tr>
                  </tbody>
                </table>
                <div style="text-align:left; font-size:14px; line-height:20px; margin:0px; border:1px solid #ccc; padding:10px 20px; background:#f8f8f8;" >
              <span style="font-size:16px;font-weight:bold; line-height:28px;">연장선택</span><br />
          <i class="bi bi-info-circle"></i> 연장 신청은 기간이 끝난 후 7일 이내에만 가능하며, 7일이 지나면 주문은 자동으로 취소됩니다.<br>
          <i class="bi bi-info-circle"></i> 동일 상품군으로만 연장이 가능하며 상품 변경을 원할 시에는 기존 아이디 만료 이후 5일 이내 <strong>연장을 체크하지 않고</strong> 새로운 아이디 주문을 넣어주시기 바랍니다. <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(연장 가능한 상품은 본사 정책에 따라 수시로 변경될 수 있습니다.)<br />
          <i class="bi bi-info-circle"></i> 상품은 1개만 선택 가능하며 중복선택은 할 수 없습니다.
          </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    v-on:click="createSubscription()" :class="{'disabled': !Object.keys(selProduct).length}">생성</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>

              </div>
            </div>
          </div>
        </div>
</template>

<script>

import Business from "./Business.vue"
  import Student from "./detail_pages/Student.vue"
  import Subscription from "./detail_pages/Subscription.vue"
  import QueryGrid from "./QueryGrid"
  import axios from "axios";


export default {
        name: 'CreateSubscription',
    props: {
        student: Object,
        subscription: Object,
        btnId: String
    },
    components: {
        Business,
        Student,
        Subscription,
        QueryGrid
    },
    mounted(){

      var now_utc = Date.now() // 지금 날짜를 밀리초로
      // getTimezoneOffset()은 현재 시간과의 차이를 분 단위로 반환
      var timeOff = new Date().getTimezoneOffset()*60000; // 분단위를 밀리초로 변환
      // new Date(now_utc-timeOff).toISOString()은 '2022-05-11T18:09:38.134Z'를 반환
      var today = new Date(now_utc-timeOff).toISOString().split("T")[0];
      document.getElementById("hopeDate").setAttribute("min", today);
      this.addData.hopeStart = today;

      this.reloadData();

      if(this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL1'){
        this.config.search_fields.push(
          {
            "id": "level_filter",
            "name": "레벨",
            "type": "switch",
            "filter_type": {
                "GK": "GK",
                "GK_1": "GK_1",
                "GR1": "GR1",
                "GR2": "GR2",
                "GR3": "GR3",
                "GR4": "GR4",
                "GR5": "GR5",
                "GR6": "GR6",
                "GR7": "GR7",
                "GR8": "GR8",
                "GR9": "GR9",
                "GR10": "GR10",
                "GR11": "GR11",
                "GR12": "GR12",
                "Sprout": "Sprout",
                "Blow": "Blow",
                "Flag": "Flag",
                "Wing": "Wing",
                "Dream": "Dream",
                "Royal": "Royal"
            }
          }
        )
      }
      else{
        if(this.$root.businesses[0].study_type == 'PLS'){
          this.config.search_fields.push(
            {
              "id": "level_filter",
              "name": "레벨",
              "type": "switch",
              "filter_type": {
                  "GK": "GK",
                  "GK_1": "GK_1",
                  "GR1": "GR1",
                  "GR2": "GR2",
                  "GR3": "GR3",
                  "GR4": "GR4",
                  "GR5": "GR5",
                  "GR6": "GR6",
                  "GR7": "GR7",
                  "GR8": "GR8",
                  "GR9": "GR9",
                  "GR10": "GR10",
                  "GR11": "GR11",
                  "GR12": "GR12"
              }
            }
          )
        }
        else{
          this.config.search_fields.push(
            {
              "id": "level_filter",
              "name": "레벨",
              "type": "switch",
              "filter_type": {
                  "Sprout": "Sprout",
                  "Blow": "Blow",
                  "Flag": "Flag",
                  "Wing": "Wing",
                  "Dream": "Dream",
                  "Royal": "Royal"
              }
            }
          )
        }
      }
      this.config.search_fields.push(
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "아이디/이름/회원번호"
        },
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "created_at": "회원가입일",
                "start_date": "시작일",
                "end_date": "종료일"
            }
        },
                {
            "id": "is_current_final",
            "name": "연장주문여부",
            "type": "switch",
            "filter_type": {
                "true": "없음",
                "false": "있음"
            }
        }
      )
    },

    methods: {
      reloadData(){
        if(this.subscription){
        this.is_extend = true;
        this.selStudent = this.student;
        this.addData.subscription = this.subscription;
        this.fetchProducts(this.addData.subscription);
        this.fetchSubscriptionsOfStudent(this.selStudent)
        this.hide_order_studentName= true
        this.hide_order_previousSub= true
        }
        else if(this.student){
        this.selStudent = this.student;
        this.fetchSubscriptionsOfStudent(this.selStudent)
        this.hide_order_studentName= true
        this.fetchProducts();
        } else {
this.fetchProducts();
        }
      },

        openModal(is_modal_opened){
            if(!is_modal_opened){
                        this.$nextTick(function(){
          var modalDom = document.getElementById("BuySub" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs.modal', function (event) {
            this.active = false;
          })

          this.payMethod = "CARD_ONPG";
          this.selmain = "";
          this.selmonth = "";
          this.selservice = "";

          modal.show();
        });


            }

            this.resetForm();
            this.fetchProducts();
        },
      fetchProducts(source) {
        var extras="?";
        if(source){
          extras += "source=" + source.id
        }
        axios.get('/products' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }


        })
      },
      fetchProductsmain() {
        //console.log(this.selmain)
        if(this.selmain === 'A'){
          this.hide_selservice = false;
        }
        else{
          this.hide_selservice = true;
        }

        axios.post('/productsMain', {
          'main': this.selmain ? this.selmain : "",
          'month': this.selmonth ? this.selmonth : "",
          'service': this.selservice ? this.selservice : ""
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }


        })

        },
            getDiff(value) {

        var moment = require('moment'); // moment 모듈불러오기

        const diff = moment().diff(value, 'hours');
        const days = Math.floor(diff / 24);
        const hours = diff % 24;

        return -days;

      },
      createSubscription() {
        var base = this.$refs.qg ? this.$refs.qg.checked : []
        if(this.hide_order_studentName){
          base = [this.student]
        }
          base.forEach((s) => {


        axios.post('/subscriptions', {
          'student': s.id,
          'product': this.selProduct.id,
          'paymentMethod': this.payMethod,
          'hopeStart': this.is_extend ? this.addData.subscription.endDate : this.addData.hopeStart,
          'level': this.is_extend ? this.addData.subscription.level : this.addData.level,
          "previous_order": this.is_extend ? this.addData.subscription.id : "",
          "subject":""
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: s.name + ' ID 추가 실패: ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: s.name + ' 신청되었습니다. (다시 검색해야 표시됩니다.)'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }


        })


          });

      },
            fetchSubscriptionsOfStudent(student) {
        var extras = "";
        console.log(student)
        axios.get('/subscriptions?student=' + student.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.ext_subscriptions = response.data.result;
            this.addData.subscription = this.ext_subscriptions[0]
            this.fetchProducts(this.addData.subscription);
          }


        })
      },
      chgExtend(){
        if(!this.is_extend){
          this.fetchProducts();
        } else {
            this.fetchSubscriptionsOfStudent(this.$refs.qg.checked[0])
        }
      },
      extendForm(){
        this.is_extend = true;
        this.selStudent = {id: this.selSub.studentId};
        this.addData.subscription = this.selSub;
        this.fetchProducts(this.selSub);
        this.fetchSubscriptionsOfStudent(this.selStudent)
        this.hide_order_studentName= true
        this.hide_order_previousSub= true
      },
      resetForm(){
          if(this.subscription || this.student) return;
        this.is_extend = false;
        this.selStudent = {};
        this.hide_order_studentName= false
        this.hide_order_previousSub= false
        this.fetchProducts();
      },
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
                    selSub: {

        },
        students: [],
        selStudent: {},
        payMethod: "",
        selProduct: {},
        products: {},
        is_extend: false,

        addData: {

        },
        hide_order_studentName: false,
        hide_order_previousSub: false,
                config: {
    "name": "학생 리스트",
    "req_endpoint": "/students",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "businesses",
            "name": "소속선택",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "status_filter",
            "name": "유형",
            "type": "switch",
            "filter_type": {
                "ACTIVE": "정회원",
                "EVENT": "이벤트회원",
                "INACTIVE": "미사용(퇴원)"
            }
        },
        {
            "id": "prod_filter",
            "name": "상품유형",
            "type": "switch",
            "filter_type": {
                "MYUSE": "My USE",
                "MYPATH": "MyPath"
            }
        }
        ,
    ],
    "columns": [
              {
            "id": "chkbox",
            "name": "체크",
        },
        {
            "id": "id",
            "sortable": true,
            "name": "회원번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "biz",
            "name": "학원",
            "excel_print": v=>{return v.t2.name}
        },
                {
            "id": "class",
            "name": "클래스",
            "excel_print": v=>{return v.t1.name}
        },
        {
            "id": "username",
            "sortable": true,
            "name": "아이디",
            "excel_print": v=>{return v.username}
        },
        {
            "id": "hanname",
            "sortable": true,
            "name": "이름",
            "excel_print": v=>{return v.name}
        },

        {
            "id": "type",
            "sortable": true,
            "name": "유형",
            "excel_print": v=>{return v.type || ''}
        },
        {
            "id": "level",
            "sortable": true,
            "name": "레벨",
            "excel_print": v=>{return v.level || ''}
        },
        {
            "id": "start_date",
            "sortable": true,
            "name": "시작일",
            "excel_print": v=>{return v.startDate || ''}
        },
        {
            "id": "end_date",
            "sortable": true,
            "name": "종료일",
            "excel_print": v=>{return v.endDate || ''}
        },
        {
            "id": "remain_days",
            "sortable": true,
            "name": "잔여일",
            "excel_print": v=>{return this.getDiff(v.endDate) || ''}
        },
        {
            "id": "status",
            "name": "상태",
            "excel_print": v=>{return (v.active_subscription_id ? (v.ranking_exception ? '이벤트' : '정회원') : '미사용')}
        }
    ]
}
        }
    }
}
</script>

<style>

</style>
